module.exports = __webpack_public_path__ + "img/hz-xh-meeting.4770bd02.png";